import { colors, focusVisible, measures, text } from "@quickpoint.me/shared";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { FileTypeToDisplay } from "../../state/fileState";

const StyledFileTabs = styled.div<{ $isInPortrait: boolean }>`
    border-block-end: 1px solid ${props => props.theme.navigationFrame};
    display: flex;
    align-items: end;
    margin-inline: ${props =>
    props.$isInPortrait ? measures.dialogPanel.portrait.margin : measures.dialogPanel.landscape.margin};
`;

/* Real text tabs (WCAG 1.4.9 — the old SVGs were images of text).
   Active #5335c9 is 7.7:1 on white and 7.2:1 on the lavender backdrop;
   inactive textSafe grey is 7:1 (AAA). */
const StyledFileTab = styled.button.attrs({ type: "button" })<{ $active: boolean }>`
    cursor: pointer;
    background: ${props => (props.$active ? props.theme.navigationBackGround : "none")};
    border: none;
    border-start-start-radius: 6px;
    border-start-end-radius: 6px;
    border-block-end: 3px solid ${props => (props.$active ? "#5335c9" : "transparent")};
    padding: 0 1.1em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    min-width: 48px;
    font-family: ${props => props.theme.font};
    font-size: 0.9rem;
    color: ${props => (props.$active ? "#5335c9" : colors.textSafe.grey)};
    ${focusVisible}

    &:hover {
        color: #5335c9;
    }
`;

const StyledButtons = styled.div`
    display: flex;
    flex-direction: row;
    grid-area: tabs;
`;

function FileTabs({ $isInPortrait }: { $isInPortrait: boolean }) {
    const [fileTypeToDisplay, setFileTypeToDisplay] = useRecoilState(FileTypeToDisplay);
    const showImages = () => {
        setFileTypeToDisplay("image");
    };

    const showData = () => {
        setFileTypeToDisplay("data");
    };

    const showAudio = () => {
        setFileTypeToDisplay("audio");
    };

    return (
        <StyledFileTabs
            $isInPortrait={$isInPortrait}
            role="group"
            aria-label={text.fileUploader.tabsLabel}
        >
            <StyledButtons>
                <StyledFileTab
                    $active={fileTypeToDisplay === "image"}
                    onClick={showImages}
                    aria-pressed={fileTypeToDisplay === "image"}
                >
                    {text.fileUploader.tabImages}
                </StyledFileTab>
                <StyledFileTab
                    $active={fileTypeToDisplay === "audio"}
                    onClick={showAudio}
                    aria-pressed={fileTypeToDisplay === "audio"}
                >
                    {text.fileUploader.tabAudio}
                </StyledFileTab>
                <StyledFileTab
                    id="file-tab-data"
                    $active={fileTypeToDisplay === "data"}
                    onClick={showData}
                    aria-pressed={fileTypeToDisplay === "data"}
                >
                    {text.fileUploader.tabData}
                </StyledFileTab>
            </StyledButtons>
        </StyledFileTabs>
    );
}

export default FileTabs;
